import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
var _obj;
/**
 * @deprecated use #getDefaultLocale
 */ export var DEFAULT_LOCALES = (_obj = {}, _define_property(_obj, Language.ENG, "en"), _define_property(_obj, Language.FRA, "fr-FR"), _define_property(_obj, Language.DEU, "de-DE"), _define_property(_obj, Language.ITA, "it-IT"), _define_property(_obj, Language.SPA, "es-ES"), _define_property(_obj, Language.SWE, "sv-SE"), _define_property(_obj, Language.DAN, "da-DK"), _define_property(_obj, Language.POR, "pt-PT"), _define_property(_obj, Language.NLD, "nl-NL"), _define_property(_obj, Language.GIBBERISH, "xa"), _define_property(_obj, Language.STRING_ID, "xc"), _obj);
export function getDefaultLocale(key) {
    return DEFAULT_LOCALES[key];
}
